import { splitSnake, titlecase } from '@principle-theorem/shared';

export const AI_RECEPTIONIST_NUMBER_FORMAT = new Intl.NumberFormat();

export class AiReceptionistFormatters {
  private static readonly _categoryLabelAcronyms: Record<string, string> = {
    ai: 'AI',
    sms: 'SMS',
    faq: 'FAQ',
    dva: 'DVA',
    gp: 'GP',
    id: 'ID',
    otp: 'OTP',
  };

  static formatDuration(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`;
  }

  static formatCategoryLabel(value: string | null | undefined): string {
    if (
      // eslint-disable-next-line no-null/no-null
      value === null ||
      value === undefined ||
      value.trim() === '' ||
      value.trim().toLowerCase() === 'null'
    ) {
      return 'Unknown';
    }
    return titlecase(splitSnake(value))
      .split(' ')
      .map(
        (word) =>
          AiReceptionistFormatters._categoryLabelAcronyms[word.toLowerCase()] ??
          word
      )
      .join(' ');
  }
}
